var menuButton = "ProductMenu-module_menuButton__Ih-Xk";
var menu = "ProductMenu-module_menu__iOGw-";
var menuItem = "ProductMenu-module_menuItem__02s0U";
var menuItemLink = "ProductMenu-module_menuItemLink__G7b6y";
var disabled = "ProductMenu-module_disabled__TIOCM";

export { disabled, menu, menuButton, menuItem, menuItemLink };
